import React from 'react';
import { isPast, isToday } from 'helpers/dates';
import { SystemText } from 'e4shared';
import Panel from 'components/general/panel';
import FocusTile from 'views/user/1-2-1s/components/performanceDashboard/components/focusTile';

export const CoachReviews = ({ focus, data, setShow }) => {
    if (!data || data.length === 0) return null;

    const st = (path, ...rest) => SystemText(`Home/Widgets/WhatsHappening/CoachReviews/${path}`, ...rest);

    const total = data.length;
    const incomplete = data.filter(s => !s.completed).length;
    const overdue = data.filter(s => isPast(s.scheduled) && !isToday(s.scheduled)).length;
    const colour = overdue > 0 ? 'danger' : incomplete > 0 ? 'warning' : 'information';

    const slug = `${overdue ? 'Overdue' : ''}${overdue !== total ? 'Upcoming' : ''}${
        incomplete > 1 ? 'ManyComments' : incomplete > 0 ? 'OneComment' : ''
    }`;

    const message = st(slug, overdue, total - overdue);

    const date = total === 1 ? data[0].scheduled : null;

    const url = total === 1 ? `/develop/reviews/${data[0].profile_Id}` : '';

    if (focus)
        return (
            <FocusTile
                tileType="review"
                colour="information"
                icon="fa-users"
                message={message}
                url={url}
                setShow={setShow}
                date={date}
            />
        );

    return <Panel colour={colour} icon="users" message={message} url={url} setShow={setShow} />;
};

export default CoachReviews;
